// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"c23f81b3","115":"ed9a826d","186":"c1e73076","213":"c43025cb","314":"dcee5364","547":"9159aa91","561":"1fcaa766"}[chunkId] + ".chunk.js";
};